import React, { Component } from "react";

import { Redirect } from "react-router";
import ScrollContainer from "../utilitiesComponents/scrollContainerComponent";
import TeamContainer from "../adminComponents/teamContainer";
import { connect } from "react-redux";
import { loggedIn } from "src/actions/login";

class TeamPage extends Component {
  loggedIn() {
    return this.props.loggedIn();
  }
  render() {
    if (!this.props.token) {
      this.loggedIn();
      return <div />;
    }
    if (this.props.token === "invalid") {
      return <Redirect to="/login" />;
    }
    return (
      <ScrollContainer
        speed={0.8}
        smoothScrolling={true}
        className={"main-container vh-100 admin-part"}
        contentClassName={"container-fluid min-vh-100 d-flex"}
        horizontal={false}
        parentClassName="vh-100"
      >
        <TeamContainer id={this.props.match.params.id} />
      </ScrollContainer>
    );
  }
}

export default connect(
  ({ userReducer: { username, token } }) => ({
    username,
    token
  }),
  {
    loggedIn
  }
)(TeamPage);
